module.exports = __webpack_public_path__ + "static/media/JRCentralNagoyaStationPOCFeet_px215_389_0.1447429.49b40192.png";